export default "__VITE_ASSET__Bj3VldSD__"